import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Suppress ResizeObserver loop completed with undelivered notifications error
// This is a known issue with MUI and doesn't affect functionality
const resizeObserverErrorHandler = (error) => {
  if (
    error.message === "ResizeObserver loop completed with undelivered notifications."
  ) {
    return;
  }
  throw error;
};
window.addEventListener("error", resizeObserverErrorHandler);
import { ThemeProvider, createTheme } from "@mui/material";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/es/integration/react";
import { persistStore } from "redux-persist";
import Store from "./Redux/Store/Store";

const theme = createTheme({
  typography: {
    fontFamily: ["Poppins", "sans-serif"].join(","),
    fontWeightBold: "bold"
  },
  palette: {
    primary: {
      main: "#083050",
      // main:"#0F1047"
    },

  },
});
const persistor = persistStore(Store);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </PersistGate>
    </Provider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
